import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-read-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl text-foreground-50">土豪漫画网</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                土豪漫画网提供免费漫画下拉式浏览和高清韩漫人气榜。海量韩国漫画、日本漫画、国产漫画免费在线阅读，追踪热门趋势，享受视觉盛宴。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/hanman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">韩漫专区</Link></li>
                <li><Link to="/category/riman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">日漫专区</Link></li>
                <li><Link to="/category/guoman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">国漫专区</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/shaonian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">少年漫画</Link></li>
                <li><Link to="/category/shaonv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">少女漫画</Link></li>
                <li><Link to="/category/qihuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">奇幻漫画</Link></li>
                <li><Link to="/category/xuanyi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">悬疑漫画</Link></li>
                <li><Link to="/category/danmei" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">耽美漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-50 mb-4">订阅更新</h4>
              <p className="text-sm text-foreground-400 mb-3">订阅我们的更新通知，第一时间获取最新漫画上架信息。</p>
              {subscribed ? (
                <div className="flex items-center gap-2 text-primary-400 text-sm">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>订阅成功！感谢关注</span>
                </div>
              ) : (
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (!email) return;
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const hpVal = (formData.get('website_alt') as string || '').trim();
                    if (hpVal) {
                      setSubscribed(true);
                      setEmail('');
                      return;
                    }
                    formData.delete('website_alt');
                    try {
                      const resp = await fetch('https://readdy.ai/api/form/d9osomiftmtnfcfh0ddg', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as any).toString(),
                      });
                      const text = await resp.text();
                      let msg = '';
                      try {
                        const parsed = JSON.parse(text);
                        msg = parsed?.meta?.message || parsed?.message || '';
                      } catch { /* noop */ }
                      if (resp.ok && !msg.includes('spam')) {
                        setSubscribed(true);
                        setEmail('');
                      } else {
                        setSubscribed(true);
                        setEmail('');
                      }
                    } catch {
                      setSubscribed(true);
                      setEmail('');
                    }
                  }}
                  className="flex gap-2"
                  data-readdy-form=""
                >
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱"
                    className="flex-1 bg-background-800 text-sm text-foreground-200 placeholder-foreground-500 px-3 py-2 rounded-lg outline-none border border-background-700 focus:border-primary-500 transition-colors"
                  />
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="antispam-hp"
                  />
                  <button type="submit" className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                    订阅
                  </button>
                </form>
              )}
              <div className="mt-4">
                <p className="text-sm text-foreground-500">联系邮箱：contact@tuhaomanhua.com</p>
                <p className="text-sm text-foreground-500 mt-1">客服QQ：88886666</p>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2020-2026 土豪漫画网 版权所有 | 京ICP备xxxxxxxx号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}